import { EasingOptions, PointLike } from 'mapbox-gl';
import { GeoJsonProperties, SelectedAsset } from './features/types';

export * from './geocoder/types';
export * from './panel/types';

export enum MapModes {
	Full = 'full',
	Static = 'static',
	Navigation = 'navigation',
	Search = 'search',
}

export enum DistanceUnit {
	imperial = 'imperial',
	metric = 'metric',
}

export type MapSelectedAssets = SelectedAsset[];

export type MapFocusedAsset = {
	_id: string;
	assetType: string;
	systemType: string;
	geometry: GeoJSON.Geometry;
};

export type MapPanelItems = GeoJsonProperties[] | null;

export interface MapPosition {
	center: number[];
	zoom: number;
}

// Weirdly using Pick doesn't seem to work when importing into another app
export interface FitBoundsOptions {
	padding?: EasingOptions['padding'];
	zoom?: EasingOptions['zoom'];
	maxZoom?: EasingOptions['maxZoom'];
	offset?: EasingOptions['offset'];
}

export interface SelectionOptions {
	minZoom: number;
	maxFeatures: number;
}

export { SelectedAsset, GeoJsonProperties };

export enum MapFunction {
	interactive,
	backgroundControl,
	selection,
	clusterExapnsion,
	geolocateControl,
	scaleControl,
	navigationControl,
	geocoderControl,
	extentsControl,
	hoverPopup,
	marker,
}

export type LocationBox = [PointLike, PointLike];

export enum SelectionMode {
	normal,
	invert,
	add,
	subtract,
}

export interface MapState {
	drawing: boolean;
}

export type MapSetState = <T extends keyof MapState>(
	key: T,
	value: MapState[T],
) => void;
